import { Injectable } from "@angular/core";

// Source: http://www.swisstopo.admin.ch/internet/swisstopo/en/home/topics/survey/sys/refsys/projections.html (see PDFs under "Documentation")
// Updated 9 dec 2014
// Please validate your results with NAVREF on-line service: http://www.swisstopo.admin.ch/internet/swisstopo/en/home/apps/calc/navref.html (difference ~ 1-2m)

// Convert WGS lat/long (� dec) to CH y

@Injectable()
export class GeoService {


public static WGStoCHy(lat:number, lng:number): number {

    // Convert decimal degrees to sexagesimal seconds
    lat = GeoService.DECtoSEX(lat);
    lng =GeoService. DECtoSEX(lng);
  
    // Auxiliary values (% Bern)
    var lat_aux = (lat - 169028.66)/10000;
    var lng_aux = (lng - 26782.5)/10000;
    
    // Process Y
    let y = 600072.37 
       + 211455.93 * lng_aux 
       -  10938.51 * lng_aux * lat_aux
       -      0.36 * lng_aux * Math.pow(lat_aux,2)
       -     44.54 * Math.pow(lng_aux,3);
       
    return y;
  }
  
  // Convert WGS lat/long (� dec) to CH x
  public static WGStoCHx(lat:number, lng:number): number {
    
    // Convert decimal degrees to sexagesimal seconds
    lat = GeoService.DECtoSEX(lat);
    lng = GeoService.DECtoSEX(lng);
    
    // Auxiliary values (% Bern)
    var lat_aux = (lat - 169028.66)/10000;
    var lng_aux = (lng - 26782.5)/10000;
  
    // Process X
    let x = 200147.07
       + 308807.95 * lat_aux 
       +   3745.25 * Math.pow(lng_aux,2)
       +     76.63 * Math.pow(lat_aux,2)
       -    194.56 * Math.pow(lng_aux,2) * lat_aux
       +    119.79 * Math.pow(lat_aux,3);
   
    return x;    
  }
  
  // Convert CH y/x to WGS lat
  public static CHtoWGSlat(y:number, x:number) {
  
    // Converts military to civil and  to unit = 1000km
    // Auxiliary values (% Bern)
    var y_aux = (y - 600000)/1000000;
    var x_aux = (x - 200000)/1000000;
    
    // Process lat
    let lat = 16.9023892
         +  3.238272 * x_aux
         -  0.270978 * Math.pow(y_aux,2)
         -  0.002528 * Math.pow(x_aux,2)
         -  0.0447   * Math.pow(y_aux,2) * x_aux
         -  0.0140   * Math.pow(x_aux,3);
      
    // Unit 10000" to 1 " and converts seconds to degrees (dec)
    lat = lat * 100/36;
    
    return lat;    
  }
  
  // Convert CH y/x to WGS long
  public static CHtoWGSlng(y:number, x:number): number {
  
    // Converts military to civil and  to unit = 1000km
    // Auxiliary values (% Bern)
    var y_aux = (y - 600000)/1000000;
    var x_aux = (x - 200000)/1000000;
    
    // Process long
    let lng = 2.6779094
          + 4.728982 * y_aux
          + 0.791484 * y_aux * x_aux
          + 0.1306   * y_aux * Math.pow(x_aux,2)
          - 0.0436   * Math.pow(y_aux,3);
       
    // Unit 10000" to 1 " and converts seconds to degrees (dec)
    lng = lng * 100/36;
       
    return lng;    
  }
  
  // Convert angle in decimal degrees to sexagesimal seconds
  public static DECtoSEX(angle: number) {
  
    // Extract DMS
    let deg:number = Math.floor(angle);
    var min = Math.floor((angle-deg)*60);
    var sec = (((angle-deg)*60)-min)*60;   
  
    // Result sexagesimal seconds
    return sec + min*60.0 + deg*3600.0;    
  }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/services/geo.service.ts